
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.98 22.421l.003.002a.714.714 0 01.288.224c.066.084.096.17.096.275a.441.441 0 01-.135.338.441.441 0 01-.337.134H3.504c-1.076 0-1.801-.273-2.266-.738C.775 22.193.5 21.461.5 20.367V3.574c0-1.1.277-1.844.746-2.32C1.716.779 2.446.5 3.527.5h11.801c1.091 0 1.822.28 2.286.752.466.476.741 1.22.741 2.322v12.48c0 .331-.038.59-.104.788-.07.214-.16.38-.265.51a4.083 4.083 0 01-.428.454l-.007.006-.007.007c-.515.506-.859 1.073-.989 1.703-.125.605-.072 1.185.178 1.72.255.544.681.94 1.248 1.18zM4.84 1.528h-.5v15.613h11.598s0 0 0 0c.376 0 .752-.09 1.032-.36.283-.272.382-.644.382-1.02V3.669c0-.616-.163-1.166-.56-1.57-.405-.41-.977-.57-1.616-.57h0H4.84zM1.516 17.062v.869l.75-.436c.2-.116.419-.204.66-.263.118-.03.244-.052.378-.067l.051-.004.46-.037V1.497l-.55.057-.034.003-.01.001-.01.002c-.443.065-.835.235-1.135.54-.398.403-.56.953-.56 1.569v13.394zm14 5.387h.893l-.467-.761a2.903 2.903 0 01-.42-1.394 3.144 3.144 0 01.317-1.53l.389-.822-.903.113a23.99 23.99 0 00-.186.024.977.977 0 01-.127.007H3.797c-.662 0-1.247.181-1.69.599-.439.412-.65.95-.65 1.565 0 .625.175 1.18.581 1.597.42.43 1.01.602 1.677.602h11.8z","fill":"#748190","stroke":"#748190"}})])
          )
        }
      }
    